import "../news-search.css";
import generatedNewsArticles from "./news.generated.json";

const REAL_NEWS_FALLBACKS = {
  rohith: "https://images.ottplay.com/images/thrigun-954.jpeg?height=675&impolicy=ottplay-202501_high&width=1200",
  thrigun: "https://images.ottplay.com/images/thrigun-954.jpeg?height=675&impolicy=ottplay-202501_high&width=1200",
  debjani: "https://feeds.abplive.com/onecms/images/uploaded-images/2023/05/02/aad39363bd7bda0950dd259a835309b1b3c42.jpg?impolicy=abp_cdn&imwidth=720",
  varshini: "https://cdn.gulte.com/wp-content/uploads/2020/05/Varshini-Sounderajan-Bigg-Boss-4.jpg",
  chaitra: "https://feeds.abplive.com/onecms/images/uploaded-images/2024/03/11/75638590021698c58ba447cdbd0970fe1710169103228882_original.jpg?height=675&impolicy=abp_cdn&imwidth=1200",
  season10: "https://images.news18.com/telugu/uploads/2026/06/Bigg-boss-Telugu-2026-06-8fea7ba1cc6b56d9448a548a3e959ac4-1200x675.jpg",
};

const FALLBACK_IMAGE = REAL_NEWS_FALLBACKS.season10;
const GOOGLE_NEWS_BASE_QUERY = "Bigg Boss Telugu";
const GOOGLE_NEWS_RSS_URL = "https://news.google.com/rss/search?q=";
const RSS2JSON_URL = "https://api.rss2json.com/v1/api.json?rss_url=";
const BROWSER_NEWS_STORAGE_KEY = "bb_telugu_browser_news_v2";
const BROWSER_NEWS_SEARCH_CACHE_KEY = "bb_telugu_browser_news_search_v1";

const FULL_ARTICLE_PREVIEW = [
  "Rohit Naidu and Thrigun have become involved in an early disagreement inside the Bigg Boss Telugu 10 house, with responsibilities and differences in how house tasks are being handled at the centre of the discussion.",
  "The exchange has quickly become one of the early talking points of the season. Disagreements over team decisions and day-to-day responsibilities are already starting to shape the atmosphere inside the house, where contestants are still settling into their roles.",
  "For viewers, these early clashes can become important because house dynamics often develop through repeated interactions around tasks, responsibilities and group decisions. A single disagreement can therefore become part of a wider pattern as the week progresses.",
  "At this stage, the available report points to the disagreement itself rather than a confirmed longer-running fallout. The situation will depend on how the contestants respond during upcoming conversations and house activities.",
  "For the latest confirmed details, images and any subsequent developments, the original Times of India report remains the source linked from this page.",
];

const seedNewsArticles = [
  {
    id: "season-10-launch",
    slug: "bigg-boss-telugu-10-grand-launch",
    title: "Bigg Boss Telugu 10 launches with 16 housemates and the Dhasavatharam theme",
    category: "Season 10",
    date: "2026-09-07",
    source: "Cinema Express",
    sourceUrl: "https://www.cinemaexpress.com/telugu/news/2026/Sep/07/bigg-boss-telugu-season-10-meet-the-contestants-of-the-latest-edition-of-the-reality-show",
    excerpt: "Season 10 opened with a 16-member house and a new Dhasavatharam concept, bringing familiar television faces, actors, creators and Agnipariksha selections into the competition.",
    image: FALLBACK_IMAGE,
    videoId: "",
  },
  {
    id: "jhansi-agnipariksha",
    slug: "jhansi-wins-agnipariksha-bigg-boss-telugu-10",
    title: "Folk singer Jhansi earns direct entry into Bigg Boss Telugu 10",
    category: "Breaking",
    date: "2026-09-06",
    source: "Times of India",
    sourceUrl: "https://timesofindia.indiatimes.com/tv/news/telugu/bigg-boss-telugu-10-from-agnipariksha-to-dhasavatharam-everything-you-need-to-know-before-the-grand-premiere/photostory/133809047.cms",
    excerpt: "Jhansi emerged from the Agnipariksha route with a direct ticket into the Season 10 house, adding a grassroots story to the new season.",
    image: FALLBACK_IMAGE,
    videoId: "",
  },
  {
    id: "rohit-thrigun-clash",
    slug: "rohit-naidu-thrigun-clash-season-10",
    title: "Rohit Naidu and Thrigun clash over house responsibilities",
    category: "House Buzz",
    date: "2026-09-12",
    source: "Times of India",
    sourceUrl: "https://timesofindia.indiatimes.com/tv/news/telugu/bigg-boss-telugu-10-rohit-and-thrigun-lock-horns/articleshow/134076430.cms",
    excerpt: FULL_ARTICLE_PREVIEW.join("\n\n"),
    image: REAL_NEWS_FALLBACKS.thrigun,
    videoId: "",
  },
  {
    id: "chaitra-rai-rumours",
    slug: "chaitra-rai-eviction-rumours",
    title: "Chaitra Rai eviction rumours circulate online — no official confirmation yet",
    category: "Rumours",
    date: "2026-09-12",
    source: "Times of India",
    sourceUrl: "https://timesofindia.indiatimes.com/tv/news/telugu/bigg-boss-telugu-10-chaitra-rai-to-get-evicted/articleshow/134074048.cms",
    excerpt: "Social media speculation has triggered discussion around Chaitra Rai, but reports currently stop short of an official confirmation from the makers or broadcaster.",
    image: REAL_NEWS_FALLBACKS.chaitra,
    videoId: "",
  },
];

function normalize(value = "") {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}

function isUnavailableAsset(url = "") {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return !url || host === "news.google.com" || host.endsWith(".google.com") || host.endsWith(".googleusercontent.com") || host.endsWith(".gstatic.com") || host === "placehold.co";
  } catch {
    return true;
  }
}

function realFallbackForArticle(article) {
  const text = normalize(`${article.title || ""} ${article.excerpt || ""}`);
  if (text.includes("thrigun") || text.includes("rohith") || text.includes("rohit")) return REAL_NEWS_FALLBACKS.thrigun;
  if (text.includes("chaitra")) return REAL_NEWS_FALLBACKS.chaitra;
  if (text.includes("debjani")) return REAL_NEWS_FALLBACKS.debjani;
  if (text.includes("varshini")) return REAL_NEWS_FALLBACKS.varshini;
  return FALLBACK_IMAGE;
}

function sanitizeArticle(article) {
  const image = typeof article.image === "string" ? article.image.trim() : "";
  const normalizedArticle = { ...article };
  const title = normalize(normalizedArticle.title || "");
  if (title.includes("rohit") && title.includes("thrigun")) {
    normalizedArticle.excerpt = FULL_ARTICLE_PREVIEW.join("\n\n");
  }
  if (!isUnavailableAsset(image)) return normalizedArticle;
  return { ...normalizedArticle, image: realFallbackForArticle(normalizedArticle), imageSource: "real-news-fallback" };
}

function sanitizeStoredNews(items) {
  return Array.isArray(items) ? items.map(sanitizeArticle) : null;
}

function slugify(value = "") {
  return normalize(value).replace(/\s+/g, "-").slice(0, 90) || `news-${Date.now()}`;
}

function extractImageFromHtml(html = "") {
  if (!html || typeof document === "undefined") return "";
  const node = document.createElement("div");
  node.innerHTML = html;
  const candidates = [node.querySelector("img[src]"), node.querySelector("img[data-src]"), node.querySelector("img[data-lazy-src]"), node.querySelector("source[src]")];
  for (const element of candidates) {
    const candidate = element?.getAttribute("src") || element?.getAttribute("data-src") || element?.getAttribute("data-lazy-src");
    if (candidate && /^https?:\/\//i.test(candidate) && !isUnavailableAsset(candidate)) return candidate.trim();
  }
  return "";
}

function extractRss2JsonImage(item) {
  const thumbnail = typeof item?.thumbnail === "string" ? item.thumbnail.trim() : "";
  if (!isUnavailableAsset(thumbnail)) return { image: thumbnail, source: "rss2json-thumbnail" };
  const enclosure = item?.enclosure;
  const enclosureCandidates = [typeof enclosure === "string" ? enclosure : "", enclosure?.link, enclosure?.url, enclosure?.href];
  for (const candidate of enclosureCandidates) {
    if (typeof candidate === "string" && /^https?:\/\//i.test(candidate.trim()) && !isUnavailableAsset(candidate.trim())) return { image: candidate.trim(), source: "rss2json-enclosure" };
  }
  for (const html of [item?.content, item?.description]) {
    const image = extractImageFromHtml(typeof html === "string" ? html : "");
    if (image) return { image, source: "rss2json-content-image" };
  }
  return { image: "", source: "none" };
}

function getBrowserStoredNews() {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(BROWSER_NEWS_STORAGE_KEY);
    const parsed = value ? JSON.parse(value) : null;
    if (!Array.isArray(parsed) || !parsed.length) return null;
    return sanitizeStoredNews(parsed);
  } catch { return null; }
}

function getSearchCache() {
  if (typeof window === "undefined") return {};
  try {
    const parsed = JSON.parse(window.localStorage.getItem(BROWSER_NEWS_SEARCH_CACHE_KEY) || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch { return {}; }
}

function putSearchCache(key, articles) {
  if (typeof window === "undefined") return;
  try {
    const cache = getSearchCache();
    cache[key] = articles;
    const keys = Object.keys(cache);
    if (keys.length > 12) delete cache[keys[0]];
    window.localStorage.setItem(BROWSER_NEWS_SEARCH_CACHE_KEY, JSON.stringify(cache));
  } catch {}
}

function getPersistedSearchArticle(slug) {
  if (!slug || typeof window === "undefined") return null;
  try {
    const cache = getSearchCache();
    for (const articles of Object.values(cache)) {
      if (!Array.isArray(articles)) continue;
      const match = articles.find((article) => article?.slug === slug);
      if (match) return sanitizeArticle(match);
    }
  } catch { return null; }
  return null;
}

function getCurrentArticleSlug() {
  if (typeof window === "undefined") return "";
  const match = window.location.pathname.match(/^\/news\/([^/]+)$/);
  return match ? decodeURIComponent(match[1]) : "";
}

function getInitialNewsArticles() {
  const stored = getBrowserStoredNews();
  const base = stored || (Array.isArray(generatedNewsArticles) && generatedNewsArticles.length ? generatedNewsArticles : seedNewsArticles).map(sanitizeArticle);
  const currentSearchArticle = getPersistedSearchArticle(getCurrentArticleSlug());
  if (currentSearchArticle && !base.some((article) => article.slug === currentSearchArticle.slug)) return [...base, currentSearchArticle];
  return base;
}

function mapRss2JsonItem(item, index) {
  const title = typeof item.title === "string" ? item.title.trim() : "";
  const sourceUrl = typeof item.link === "string" ? item.link.trim() : "";
  const source = typeof item.author === "string" && item.author.trim() ? item.author.trim() : typeof item.source === "string" && item.source.trim() ? item.source.trim() : "Google News";
  const rawDescription = typeof item.description === "string" ? item.description : "";
  const rawContent = typeof item.content === "string" ? item.content : "";
  const cleanDescription = rawDescription.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  const cleanContent = rawContent.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  const description = cleanDescription || cleanContent;
  const extendedContext = cleanContent && normalize(cleanContent) !== normalize(cleanDescription) ? `${description}\n\n${cleanContent}` : description;
  const published = item.pubDate ? new Date(item.pubDate) : null;
  const date = published && !Number.isNaN(published.getTime()) ? published.toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
  const extracted = extractRss2JsonImage(item);
  const fallback = realFallbackForArticle({ title, excerpt: extendedContext });
  return {
    id: `rss2json-${slugify(title)}-${index}`,
    slug: `rss2json-${slugify(title)}`,
    title,
    category: "Latest News",
    date,
    source,
    sourceUrl,
    excerpt: extendedContext,
    image: extracted.image || fallback,
    imageSource: extracted.image ? extracted.source : "real-news-fallback",
    videoId: "",
  };
}

const initialNews = getInitialNewsArticles();
export const newsArticles = initialNews;
const defaultNewsArticles = initialNews.slice();

function replaceNewsArray(next) {
  newsArticles.splice(0, newsArticles.length, ...next);
  return newsArticles;
}

export async function refreshNewsFromGoogleInBrowser(searchQuery = "") {
  if (typeof window === "undefined" || typeof window.fetch !== "function") return null;
  const normalizedQuery = normalize(searchQuery);
  const trimmedQuery = searchQuery.trim();
  const queryText = normalizedQuery ? `${GOOGLE_NEWS_BASE_QUERY} ${trimmedQuery}` : GOOGLE_NEWS_BASE_QUERY;
  const cacheKey = normalizedQuery || "__default__";
  if (normalizedQuery) {
    const cached = getSearchCache()[cacheKey];
    if (Array.isArray(cached) && cached.length) {
      const sanitized = sanitizeStoredNews(cached);
      putSearchCache(cacheKey, sanitized);
      replaceNewsArray(sanitized);
      window.dispatchEvent(new CustomEvent("bigg-boss-news-updated", { detail: sanitized }));
      return sanitized;
    }
  }
  try {
    const googleRssUrl = `${GOOGLE_NEWS_RSS_URL}${encodeURIComponent(queryText)}&hl=en-IN&gl=IN&ceid=IN:en`;
    const requestUrl = `${RSS2JSON_URL}${encodeURIComponent(googleRssUrl)}`;
    const response = await window.fetch(requestUrl, { method: "GET", credentials: "omit", mode: "cors" });
    if (!response.ok) throw new Error(`rss2json returned HTTP ${response.status}`);
    const data = await response.json();
    if (data?.status && data.status !== "ok") throw new Error(data.message || "rss2json rejected the feed");
    const browserArticles = Array.isArray(data?.items) ? data.items.map(mapRss2JsonItem).filter((article) => article.title && article.sourceUrl).map(sanitizeArticle) : [];
    if (!browserArticles.length) throw new Error("rss2json returned no usable articles");
    putSearchCache(cacheKey, browserArticles);
    if (!normalizedQuery) window.localStorage.setItem(BROWSER_NEWS_STORAGE_KEY, JSON.stringify(browserArticles));
    replaceNewsArray(browserArticles);
    window.dispatchEvent(new CustomEvent("bigg-boss-news-updated", { detail: browserArticles }));
    return browserArticles;
  } catch (error) {
    console.warn(`[Bigg Boss] rss2json fetch failed${normalizedQuery ? ` for search "${trimmedQuery}"` : ""}. Keeping the available news feed.`, error);
    if (normalizedQuery) {
      replaceNewsArray(defaultNewsArticles.slice());
      window.dispatchEvent(new CustomEvent("bigg-boss-news-updated", { detail: newsArticles }));
    }
    return null;
  }
}

if (typeof window !== "undefined" && !getCurrentArticleSlug()) {
  void refreshNewsFromGoogleInBrowser();
}

export { seedNewsArticles };
export const articleCategories = ["All", "Season 10", "Breaking", "House Buzz", "Rumours", "Voting", "Eliminations", "Interviews", "Latest News"];
